import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { breakpoints } from 'styles/basic';

interface ContentProps {
  withSidebar: boolean;
}

interface SpecialDesignProps {
  isSpecialDesign?: boolean;
}

const Wrapper = styled.div<SpecialDesignProps>`
  ${(props) => props.isSpecialDesign && css`
    background: #f3d165;
  `}
`;

const Main = styled.section`
  padding: ${(props) => props.theme.layout.mobilePadding} 0;

  @media (min-width: ${breakpoints.smallTablet}) {
    padding: ${(props) => props.theme.layout.padding} 0;
  }

  @media (min-width: ${breakpoints.smallLaptop}) {
    display: flex;
    flex: 0 0 auto;
  }
`;

const Content = styled.main<ContentProps>`
  overflow: hidden;
  width: 100%;

  ${(props) => props.withSidebar && css`
    @media (min-width: ${breakpoints.smallLaptop}) {
      width: calc(100% - 26.9rem - 3rem);
    }

    @media (min-width: ${breakpoints.laptop}) {
      width: calc(100% - 31.9rem - 3rem);
    }
  `};
`;

const SideBar = styled.aside`
  display: block;
  margin-top: 3rem;
  padding-top: 3rem;
  border-top: .3rem solid ${(props) => props.theme.colorMono.black};

  @media (min-width: ${breakpoints.smallLaptop}) {
    width: 26.9rem;
    margin-top: 0;
    margin-left: 3rem;
    padding-top: 0;
    padding-left: 3rem;
    border-top: 0;
    border-left: .3rem solid ${(props) => props.theme.colorMono.black};
  }

  @media (min-width: ${breakpoints.laptop}) {
    width: 31.9rem;
  }
`;

const Background = styled.div`
  display: flex;
  justify-content: center;
  background: ${(props) => props.theme.colorMono.black};
  img {
    display: block;
    width: 80%;
  }

  @media (min-width: ${breakpoints.landscapeTablet}) {
    img {
      width: 60%;
    }
  }

  @media (min-width: ${breakpoints.laptop}) {
    img {
      width: 40%;
    }
  }
`;

export {
  Wrapper,
  Main,
  Content,
  SideBar,
  Background
};
